/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-05-07 10:09:22
 * @LastEditors: JDY
 */
// 卡片列表
const list = {
    data () {
        return {
            orderID: 'id',
            orderVal: 'desc',
            element: '.screenfull', // 全屏dom
            params: {
                perpage: 12
            },
            pagination: { // 列表分页
                pageSizeOptions: ['12', '18', '54', '99'],
                showSizeChanger: true, // 是否显示选择下拉分页
                showQuickJumper: true, // 是否显示跳转页码
                onShowSizeChange: (current, pageSize) => { // 下拉分页选择
                    this.params.perpage = pageSize
                    this.params.page = 1
                    this.getLists()
                },
                onChange: (current, pageSize) => { // 点击分页
                    this.pagination.current = current
                    this.params.page = current
                    this.getLists()
                }
            }
        }
    },
    watch: {

    },
    methods: {
        /**
         * toolbar点击
         * @change
         */
        toolBarChange (size, setting) {
            if (size) {
                this.size = size
            }
            if (setting) {
                this.columns = setting
            }
        },
        /**
         * 筛选：排序筛选
         *params:{}
         * @params
         */
        handleChangeOrder () {
            const sort = {}
            sort[this.orderID] = this.orderVal // sort键值
            this.params.sort = sort
            this.getLists()
        },

        /**
         * 筛选：状态筛选
         * params:{}
         * @params
         */
        searchChangeState (e) {
            if (e.target.value !== '0') {
                const { where } = this.params
                where.state = e.target.value // 状态筛选赋值
            } else {
                delete this.params.where.state // 状态全部，删除键
            }
            this.getLists()
        },

        /**
         * 筛选：日期筛选
         * params:{
         *  created_at_start
         *  created_at_end
         * }
         *
         * @params
         */
         handleChangeDate (values, name) {
            this.params.page = 1
            this.pagination.current = 1 // 分页重置
            const arr = name ?? ['created_at_start', 'created_at_end']
            if (values.length !== 0) {
                const start = this.moment(values[0]).format('YYYY-MM-DD') // 日期格式转换
                const end = this.moment(values[1]).format('YYYY-MM-DD') // 日期格式转换
                this.params.where[arr[0]] = start
                this.params.where[arr[1]] = end
            } else {
                delete this.params.where[arr[0]] // 清空日期删除键
                delete this.params.where[arr[1]]
            }
            this.getLists()
        }

    }

}
export default list
